import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalCreateDemoSpace: ExperimentalMutations['experimentalCreateDemoSpace'] =
	async (_, { spaceKey, spaceName }, { network }) => {
		if (!spaceKey) {
			throw new Error('spaceKey is missing.');
		}
		if (!spaceName) {
			throw new Error('spaceName is missing.');
		}

		const keyResponse = await network.cfetch(`/wiki/rest/onboarding/1/space`, {
			method: 'POST',
			headers: {
				Accept: MediaType.JSON,
				'Content-Type': MediaType.JSON,
			},
			body: JSON.stringify({ key: spaceKey, name: spaceName }),
		});

		let key;
		try {
			({ key } = await keyResponse.json());
		} catch (e) {
			throwErrorWithResponse(new Error(`/space ${e.message}`), keyResponse);
		}

		const draftIdResponse = await network.cfetch(
			`/wiki/rest/onboarding/1/draft/generate?spaceKey=${key}`,
			{
				method: 'GET',
			},
		);

		let draftId;
		try {
			draftId = await draftIdResponse.json();
		} catch (e) {
			throwErrorWithResponse(new Error(`/draft/generate ${e.message}`), draftIdResponse);
		}

		return { key, draftId };
	};
